import {
    Component,
    OnInit,
    OnDestroy,
    AfterViewInit,
    NgModule,
    HostListener,
    ViewChild,
    ViewChildren,
    ChangeDetectorRef,
    QueryList,
    ElementRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';

// ** rxjs
import { finalize, switchMap, tap, filter } from 'rxjs/operators';
import { of, Observable, pipe, forkJoin } from 'rxjs';

// ** service
import { MessageService } from '@app/core/services';
import { LayoutService } from '@app/core/services/layout.service';
import { NewsService } from '@app/core/services/news.service';
import { HomeService } from '@app/core/services';
import { LanguageService } from '@app/core/services';
import { TranslateService } from '@ngx-translate/core';

// ** com
import { SwiperComponent } from 'swiper/angular';

// * primeng
import { Accordion } from 'primeng/accordion';

// ** 第三方
import SwiperCore, { EffectFade, Navigation, Thumbs, Scrollbar, Autoplay, Pagination } from 'swiper';
SwiperCore.use([EffectFade, Navigation, Thumbs, Scrollbar, Autoplay, Pagination]);

// ** others

@Component({
    selector: 'app-index',
    templateUrl: 'index.component.html',
    styleUrls: ['./index.component.scss'],
    providers: [MessageService],
})
export class IndexComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChildren(Accordion) accordions: QueryList<Accordion>;
    @ViewChild('heroSwiper', { static: false }) heroSwiper: SwiperComponent;
    @ViewChild('securitySwiper', { static: true })
    securitySwiper: SwiperComponent;
    // @ViewChild('solutionSwiper', { static: true }) solutionSwiper: SwiperComponent;
    @ViewChild('collabSwiper', { static: true }) collabSwiper: SwiperComponent;
    @ViewChildren('pyramidPic') pyramidPics: QueryList<ElementRef>;
    @ViewChildren('flip') flips: QueryList<ElementRef>;

    pagination = 3;
    pagination1 = 1;
    thumbsSwiperBanner: any;
    thumbsSwiperRelation: any;

    /** swiper 是否顯示 */
    showSwiper = false;
    isBrowser = false;

    /** swiper current 頁數 reference */
    carouselPageRef = 1;

    /** slide 數 */
    slidesPerView = 1;

    /** 服務統計 fliper */
    fliper = [
        { Type: 'organization', Count: 34, Title: '' },
        { Type: 'project', Count: 57, Title: '' },
        { Type: 'solution', Count: 183, Title: '' },
    ];

    /** 服務統計 標題 */
    securityTitle = '';
    /** 服務統計 中文序號 map */
    serviceMap = { organization: 0, project: 1, solution: 2 };
    /** 服務統計 三張卡片是否是進到畫面的 observer */
    observer;

    /** 三安 tab index */
    tabIdx;

    /** 輪播新聞 */
    highlightNews;

    /** 圖片類型 */
    private readonly pyramidImageTypes = ['nation', 'info', 'order'] as const;

    /** 圖片尺寸斷點 */
    private readonly imageBreakpoints = {
        sm: 390,
        md: 1024,
        lg: 1440,
    } as const;

    /** 合作對象 idx */
    accPoliticalIndex = -1;
    accEnterpriseIndex = -1;

    governmentFront = [];
    governmentBack = [];
    enterpriseFront = [];
    enterpriseBack = [];

    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
        if (this.isBrowser) this.onWindowResize();
    }

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId,
        private cdr: ChangeDetectorRef,
        private newsService: NewsService,
        private homeService: HomeService,
        private layoutService: LayoutService,
        private languageService: LanguageService,
        public router: Router,
        private translateService: TranslateService,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser) this.onWindowResize();
    }

    ngOnInit() {
        const canonical = this.document.querySelector('link[rel="canonical"]') as HTMLAnchorElement | null;
        if (canonical) canonical.href = 'https://www.kunyoutech.com.tw';
        this.initializeTranslations();
        this.getHighlightNews();
        this.getCooperations();
    }

    ngAfterViewInit() {
        // 初始化所有圖片
        setTimeout(() => {
            if (this.tabIdx === undefined) {
                this.tabIdx = 0;
            }
            this.updateAllPyramidImages();
        });
    }

    // - 初始化翻譯文字
    initializeTranslations() {
        const title = this.translateService.instant('homePage.security.title');
        this.fliper = this.fliper.map(item => ({ ...item, Title: title }));
        this.securityTitle = title;

        // 監聽語言變更
        this.languageService.onLanguageChange.subscribe(() => {
            const newTitle = this.translateService.instant('homePage.security.title');
            this.fliper = this.fliper.map(item => ({
                ...item,
                Title: newTitle,
            }));
            this.securityTitle = newTitle;
            // 語言變更時要更新所有圖片
            this.updateAllPyramidImages();
        });
    }

    // - 根據當前視窗大小取得圖片尺寸
    private getCurrentImageSize(): keyof typeof this.imageBreakpoints {
        if (!this.isBrowser) return 'md';

        const width = window.innerWidth;
        if (width <= this.imageBreakpoints.sm) return 'sm';
        if (width <= this.imageBreakpoints.md) return 'md';
        return 'lg';
    }

    // - 生成金字塔圖片路徑
    private generatePyramidImagePath(index: number): string {
        const imageType = this.pyramidImageTypes[index];
        const isEnglish = this.languageService.getCurrentLang() === 'en-us';

        // 中文時統一使用 1024 尺寸，英文時根據螢幕大小選擇
        if (isEnglish) {
            const size = this.getCurrentImageSize();
            const sizeMap = {
                sm: '390',
                md: '1024',
                lg: '1440',
            };
            return `/assets/images/indexPage/pyramid-${sizeMap[size]}-${imageType}-english.png`;
        } else {
            // 中文模式固定使用 1024 尺寸的 webp 圖片
            return `/assets/images/indexPage/pyramid-1024-${imageType}.webp`;
        }
    }

    // - 更新所有金字塔圖片（包括 swiper 中的多張圖片）
    private updateAllPyramidImages(): void {
        if (!this.pyramidPics) {
            return;
        }
    
        // 更新所有圖片（桌面版 + swiper 中的 3 張圖片）
        this.pyramidPics.forEach((pyramidPic, index) => {
            if (pyramidPic?.nativeElement) {
                let imageIndex: number;
                if (index === 0) {
                    // 桌面版圖片，使用當前 tabIdx
                    imageIndex = this.tabIdx || 0;
                } else {
                    // swiper 中的圖片，按順序：1->0(nation), 2->1(info), 3->2(order)
                    imageIndex = index - 1;
                }

                const imagePath = this.generatePyramidImagePath(imageIndex);
                pyramidPic.nativeElement.src = imagePath;
            }
        });
    }

    // - 依據 window size 調整 swiper 顯示 slide 數量
    onWindowResize() {
        const sm = window.innerWidth <= 440;
        if (sm) this.updateSlidePerPage(1.4);
        else this.updateSlidePerPage(1);
        this.updateScroll();

        // 重設 security swiper 回到第一張 slide (國安)
        if (this.securitySwiper?.swiperRef) {
            this.securitySwiper.swiperRef.slideTo(0);
            this.tabIdx = 0;
        }

        // 只有語系是英文才需要更新圖片
        const isEnglish = this.languageService.getCurrentLang() === 'en-us';
        if (isEnglish) {
            this.updateAllPyramidImages();
        }
    }

    // - manual update swiper scrollbar for ng lifecycle hotfix
    updateScroll() {
        setTimeout(() => {
            this.heroSwiper?.swiperRef?.scrollbar.updateSize();
            this.heroSwiper?.swiperRef?.scrollbar.setTranslate();
        });
    }

    // - 更新品牌優勢幻燈片
    updatePageIdx() {
        this.carouselPageRef = this.heroSwiper.swiperRef.activeIndex + 1;
        this.cdr.detectChanges();
    }

    // - 深入瞭解
    goViewNews(prefix, fileTitle) {
        return `newsCenter/${prefix}/${fileTitle}`;
    }

    // - 取得輪播新聞
    getHighlightNews() {
        of(this.layoutService.setPageLoading(true))
            .pipe(
                switchMap(() => forkJoin([this.getNews$(), this.getElectronicNews$()])),
                tap(([news, eNews]) => (this.highlightNews = [...news, ...eNews].filter(x => x.Highlight))),
                tap(() => {
                    this.highlightNews.sort((a, b) => {
                        const dateA = new Date(a.Date);
                        const dateB = new Date(b.Date);
                        return dateB.getTime() - dateA.getTime();
                    });
                    this.highlightNews = this.highlightNews.slice(0, 5);
                }),
                tap(() => this.initSwiper()),
                finalize(() => this.layoutService.setPageLoading(false)),
            )
            .subscribe();
    }

    // - 取得 milestone 資料
    getCooperations() {
        of(this.layoutService.setPageLoading(true))
            .pipe(
                switchMap(() => this.getCooperations$()),
                tap(res => {
                    this.governmentFront = res.filter(item => {
                        return item.Type === 'government' && item.Sort === 'front';
                    });
                    this.governmentBack = res.filter(item => {
                        return item.Type === 'government' && item.Sort === 'back';
                    });
                    this.enterpriseFront = res.filter(item => {
                        return item.Type === 'enterprise' && item.Sort === 'front';
                    });
                    this.enterpriseBack = res.filter(item => {
                        return item.Type === 'enterprise' && item.Sort === 'back';
                    });
                }),
                finalize(() => this.layoutService.setPageLoading(false)),
            )
            .subscribe();
    }

    // - 初始化 swiper
    initSwiper() {
        setTimeout(() => (this.showSwiper = true));
        setTimeout(() => {
            this.heroSwiper?.swiperRef?.on('slideChange', e => this.updatePageIdx());
            this.securitySwiper?.swiperRef?.on('slideChange', e => this.onSecuritySwiperChange(e));
        });
    }

    /** 當前語系是否為英文 */
    isEnglish(): boolean {
        return this.languageService.getCurrentLang() === 'en-us';
    }

    updateSlidePerPage(val: number) {
        this.slidesPerView = val;
    }

    onTabChange(e) {
        const { index } = e;
        this.tabIdx = index;

        const imagePath = this.generatePyramidImagePath(index);
        // 更新圖片
        if (this.pyramidPics?.first?.nativeElement) {
            this.pyramidPics.first.nativeElement.src = imagePath;
        }
        this.securityTitle = this.translateService.instant('homePage.security.title');
        // 切換 swiper
        this.securitySwiper.swiperRef.slideTo(index);
    }

    onSecuritySwiperChange(e) {
        this.onTabChange({ index: e.activeIndex });
    }

    ngOnDestroy() {
        const body = this.document.getElementsByTagName('body')[0];
        body?.classList.remove('index-page');
    }

    /* -------------------------------------------------------------------------- */
    /*                                     api                                    */
    /* -------------------------------------------------------------------------- */

    getNews$(): Observable<any> {
        return this.newsService.getNews().pipe();
    }

    getElectronicNews$(): Observable<any> {
        return this.newsService.getElectronicNews().pipe();
    }

    getCooperations$(): Observable<any> {
        return this.homeService.getCooperations().pipe();
    }
}
